module.exports = __webpack_public_path__ + "static/media/vithas@3x.bd3fbd61.jpg";